import { Database } from './database.types'
import { LocalStorage } from './local-storage'
import { MemoryStorage } from './memory-storage'
import { isLocalStorageEnabled } from '../utils'

export function databaseFactory(organizationName: string, databaseNameSpace?: string): Database {
  const databaseType = isLocalStorageEnabled()
    ? 'local-storage'
    : 'memory-storage'
  switch (databaseType) {
    case 'local-storage':
      return new LocalStorage(organizationName, databaseNameSpace)
    case 'memory-storage':
      return new MemoryStorage()
    default:
      throw new Error(`Database type ${databaseType} not supported`)
  }
}
